import { ru } from "./ru";
const userLocale =
  navigator.languages && navigator.languages.length
    ? navigator.languages[0]
    : navigator.language;

export const locale = new Proxy(ru, {
  get(_, prop) {
    if(userLocale.startsWith('ru')) {
      return ru[prop as keyof typeof ru]
    } else {
      return ru[prop as keyof typeof ru]
    }
  }
}) as typeof ru
